import css from 'styled-jsx/css';
import { icons, typography } from '../../../../../config/styles';
import colors from '../../../../../config/styles/colors';
import { svgToDataUri } from '../../../../../utils/styles/svgMixins';

export const AvailabilityDesktopStyles = css`
  /* Block: Main availability desktop component */
  .availability-desktop {
    width: 100%;
  }

  /* Element: Container for availability items */
  .availability-desktop__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  /* Modifier: Container with new HD options */
  .availability-desktop__container--new-hd-options {
    /* Additional styles for new HD options */
  }

  /* Element: Downloadable section wrapper */
  .availability-desktop__downloadable {
    width: 100%;
  }

  /* Element: Individual availability item wrapper */
  .availability-desktop__item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: auto;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    font-weight: 400;
    font-style: Regular;
    leading-trim: NONE;
    letter-spacing: 0%;
    vertical-align: middle;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: 0%;
    font-size: 16px;
  }

  /* Element: Divider between sections */
  .availability-desktop__divider {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    height: auto;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
  }

  /* Element: Divider text */
  .availability-desktop__divider-text {
    width: 100%;
    text-align: left;
    font-weight: 700;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  /* Legacy compatibility classes for child components */
  .availability-desktop :global(.availability-item) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    height: auto;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    padding: 8px 0 8px 0;
  }

  .availability-desktop :global(.availability-item.title) {
    span.softline-title {
      padding-top: 5px;
    }
    span {
      width: 100%;
      text-align: left;
      font-weight: 700;
      font-size: 14px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  .availability-desktop :global(.availability-item .icon) {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .availability-desktop :global(.availability-item.rebranded .deliveryAvailable) {
    background-image: url('${svgToDataUri(icons.homeDeliveryMint)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .whitelabel-deliveryAvailable) {
    background-image: url('${svgToDataUri(icons.whitelabel_homeDeliveryMint)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .siteToStoreAvailable) {
    background-image: url('${svgToDataUri(icons.buyInStoreIconRebranded)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .pickupInStoreAvailable) {
    background-image: url('${svgToDataUri(icons.pickUpInStoreMint)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .whitelabel-pickupInStoreAvailable) {
    background-image: url('${svgToDataUri(icons.whitelabel_pickUpInStoreMint)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .see-stores) {
    height: 24px;
    width: 24px;
    flex-shrink: 0;
    background-image: url('${svgToDataUri(icons.stockInStoreMint)}');
  }

  .availability-desktop :global(.availability-item.rebranded .downloadAvailable) {
    background-image: url('${svgToDataUri(icons.downloadIconRebranded)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.rebranded .purchaseOnlineAvailable) {
    background-image: url('${svgToDataUri(icons.purchaseOnlineAvailableIconRebranded)}');
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  .availability-desktop :global(.availability-item.lastItem) {
    border-bottom: 1px solid ${colors.gray.shade3};
  }

  /* Base content styles - required for proper alignment */
  .availability-desktop :global(.availability-item .content) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    width: 100%;
    color: #333;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    gap: 16px;
  }

  /* Main content area (left side) */
  .availability-desktop :global(.availability-item .content > div:first-child) {
    display: flex;
    flex-direction: column;
  }

  /* Apply underline only to the main text span */
  .availability-desktop :global(.availability-item .content > div:first-child > span) {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  /* Badges container (right side) */
  .availability-desktop :global(.availability-item .content .pod-badges) {
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-shrink: 0;
    align-items: center;
    text-decoration: none;
  }

  /* Individual badge styles */
  .availability-desktop :global(.availability-item .content .pod-badges .pod-badges-item) {
    text-decoration: none !important;
    white-space: nowrap;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0;
    margin: 0;
  }

  /* Ensure badges don't inherit underline from parent */
  .availability-desktop :global(.availability-item .content .pod-badges *) {
    text-decoration: none !important;
    text-transform: inherit;
  }

  .availability-desktop :global(.availability-item .content.outofstock) {
    display: block;
    .no-delivery {
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      color: ${colors.gray.shade52};
    }
    .no-delivery-comuna {
      color: #717171;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }
  }

  .availability-desktop :global(.availability-item .content-main) {
    display: flex;
    flex-direction: column;
    .bold {
      font-weight: bold;
    }
  }

  .availability-desktop :global(.availability-item .content-main.outofstock) {
    color: ${colors.gray.shade44};
  }

  .availability-desktop :global(.availability-item .content-sub) {
    cursor: pointer;
    color: ${colors.gray.shade40};
    width: 100%;
    text-decoration: underline;
    text-underline-offset: 4px;
    div {
      outline: none;
      display: inline;
      span {
        &.caret > i {
          padding-left: 6px;
          display: inline-block;
          font-size: ${typography.xxs};
        }
      }
    }
  }

  .availability-desktop :global(.availability-item .content .placeholder-text) {
    color: ${colors.gray.shade44};
    font-size: 12px;
    letter-spacing: 0;
    line-height: 21px;
    span {
      font-weight: bold;
    }
  }

  .availability-desktop :global(.availability-item .content.downloadAvailable) {
    border-radius: 4px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .availability-desktop__container {
      padding-bottom: 8px;
    }

    .availability-desktop__item,
    .availability-desktop__divider {
      padding: 8px 0;
    }

    .availability-desktop__divider-text {
      font-size: 13px;
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }

  @media (max-width: 480px) {
    .availability-desktop__container {
      padding-bottom: 6px;
    }

    .availability-desktop__item,
    .availability-desktop__divider {
      padding: 6px 0;
      gap: 6px;
    }

    .availability-desktop__divider-text {
      font-size: 12px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }

  /* High contrast support */
  @media (prefers-contrast: high) {
    .availability-desktop__item,
    .availability-desktop__divider {
      border-color: ${colors.black};
    }

    .availability-desktop__divider-text {
      color: ${colors.black};
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    .availability-desktop * {
      transition: none !important;
      animation: none !important;
    }
  }
`;
